import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ChapterEmblem } from "@/lib/brand";

export default function AdminChapters() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/chapters").then(r => setItems(r.data)); }, []);
  return (
    <div>
      <p className="text-[10px] tracking-luxury uppercase text-gold mb-4">The Archive</p>
      <h1 className="font-editorial text-5xl mb-16 tracking-tight">Chapters</h1>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-px bg-ivory/10">
        {items.map(c => (
          <div key={c.roman} className="bg-onyx p-8">
            <div className="flex items-start justify-between">
              <ChapterEmblem roman={c.roman} size={48} stroke="#c9a961" />
              <p className={`text-[10px] tracking-widest-plus uppercase ${c.restricted ? "text-gold" : c.revealed ? "text-ivory/60" : "text-ivory/30"}`}>
                {c.restricted ? "Restricted" : c.revealed ? "Revealed" : "Concealed"}
              </p>
            </div>
            <p className="font-editorial text-4xl mt-4">{c.roman}</p>
            <p className="font-editorial-italic text-lg text-ivory/70 mt-1">{c.name}</p>
            <p className="text-[10px] tracking-widest-plus uppercase text-ivory/40 mt-3">{c.material_language || "—"}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
